<template>
  <div class="mb-6 password-conditions">
    <div
      v-for="item in $t('auth.passwordRegulation')"
      :key="item.title"
      :class="[
        'condition d-flex align-center justify-start pa-1',
        conditions.includes(item.class)
          ? 'primary--text'
          : submission === true
          ? 'error--text'
          : 'gray7--text'
      ]"
    >
      <v-icon
        x-small
        :color="colorStatus(item.class)"
        v-if="colorStatus(item.class) === 'primary'"
        >mdi-check</v-icon
      >
      <v-icon
        x-small
        :color="colorStatus(item.class)"
        v-else-if="colorStatus(item.class) === 'error'"
        >mdi-cancel</v-icon
      >
      <v-icon x-small color="gray7" v-else>mdi-circle</v-icon>
      <v-card-text class="pa-0 text-left px-2 font-regular-12">
        {{ item.title }}
      </v-card-text>
    </div>
  </div>
</template>

<script>
export default {
  name: "password-regulation",
  props: {
    submission: {
      type: Boolean,
      default: false
    },
    password: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      conditions: "",
      counter: 0
    };
  },
  methods: {
    colorStatus(val) {
      if (this.conditions.includes(val)) {
        return "primary";
      } else if (this.submission === true) {
        return "error";
      }
      return "gray7";
    },
    add(val) {
      !this.conditions.includes(val)
        ? (this.conditions = this.conditions.concat(val))
        : "";
      this.counter++;
    },
    delete(val) {
      this.conditions = this.conditions.replace(val, "");
      this.counter--;
    }
  },
  watch: {
    password(val) {
      this.counter = 0;
      const item = this.$t("auth.passwordRegulation");
      /[a-z]/.test(val) ? this.add(item[0].class) : this.delete(item[0].class);
      /[A-Z]/.test(val) ? this.add(item[1].class) : this.delete(item[1].class);
      /\d/.test(val) ? this.add(item[2].class) : this.delete(item[2].class);
      /[`!@#$%^&*()_+\-=\\[\]{};':"\\|,.<>\\/?~]/.test(val)
        ? this.add(item[3].class)
        : this.delete(item[3].class);
      val.length >= 8 ? this.add(item[4].class) : this.delete(item[4].class);
      this.counter === 5
        ? this.$emit("conditionsResult", true)
        : this.$emit("conditionsResult", false);
    }
  }
};
</script>

<style lang="scss">
@import "passwordRegulation.scss";
</style>
